import type { FC } from "react";

import { Box, Column, Row, Text } from "@hightouch/htui";

import type { FormProps, VariableScope } from "src/formkit/components/types";
import { NEW_STATIC_ICONS } from "src/formkit/components/utils";
import { getVariableOptions } from "./variable-options";

interface ValueProp {
  type: "variable";
  variable: string;
}

export const VariableInput: FC<
  Readonly<
    FormProps & {
      scope: VariableScope;
      onClose: () => void;
      onChange: (onClose: () => void, value: ValueProp) => void;
    }
  >
> = ({ scope, onClose, onChange, value }) => {
  return (
    <Column height="249px" mx={3} mt={1} overflow="auto">
      {getVariableOptions({ scope }).map(
        ({ description, label, type, variable }) => {
          const isActive = variable === value.variable;
          const Icon = NEW_STATIC_ICONS[type];
          return (
            <Row
              _hover={{
                bg: "base.background",
              }}
              alignItems="center"
              bg={isActive ? "primary.background" : undefined}
              borderBottomWidth="hairline"
              borderBottomStyle="solid"
              borderColor="base.border"
              cursor="pointer"
              key={label}
              gap={3}
              minHeight="32px"
              pointerEvents={isActive ? "none" : undefined}
              px={2}
              py="6px"
              sx={
                isActive
                  ? {
                      span: {
                        color: "primary.base",
                      },
                    }
                  : undefined
              }
              onClick={() => {
                onChange(onClose, { type: "variable", variable });
              }}
            >
              <Row alignItems="center" flexShrink={0} gap={3} width="225px">
                <Box as={Icon} color="text.secondary" fontSize="20px" />
                <Text color="text.primary" size="sm" fontWeight="medium">
                  {label}
                </Text>
              </Row>
              <Text color="text.secondary" size="sm">
                {description}
              </Text>
            </Row>
          );
        },
      )}
    </Column>
  );
};
